
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getStatesFromQuery",
      resolverType: "query",
      routePath: "/getStatesFromQuery",
      httpMethod: "POST",
    });
  